import VueI18n from '@/i18n';


const t = (key) => VueI18n.t(key);
const tc = (key, choice) => VueI18n.tc(key, choice);

export default {
  articleDetail(articleTitle) {
    return this.articleList()
      .concat([
        {
          title: articleTitle,
        },
      ]);
  },
  articleList() {
    return [
      {
        title: t('word.articles'),
        routeTo: { name: 'article-list' },
      },
    ];
  },
  commercialList() {
    return [{ title: t('phrase.all_commercials') }];
  },
  commercialTheme(title) {
    return [{ title }];
  },
  customPageDetail(title) {
    return [{ title }];
  },
  dashboardReviewer() {
    return [
      {
        routeTo: { name: 'reviewer-dashboard' },
        title: t('word.reviewer_dashboard'),
      },
    ];
  },
  organisationList(orgType) {
    let word = 'word.organisation';
    if (orgType === 'media_agency') {
      word = 'word.agency';
    }
    return [{ title: tc(word, 2) }];
  },
  organisationDetail(organisation) {
    const crumbs = [{ title: organisation.name }];
    if (organisation.type === 'media_agency') {
      // Only list of media agencies is public;
      crumbs.unshift({
        title: tc('word.agency', 2),
        routeTo: {
          name: 'organisation-list',
          query: { type: 'media_agency' },
        },
      });
    }
    return crumbs;
  },
  productList() {
    return [
      {
        routeTo: { name: 'reviewer-dashboard' },
        title: t('word.reviewer_dashboard'),
      },
      { title: t('word.marketplace') },
    ];
  },
  userProfile() {
    return [{ title: t('phrase.my_account') }];
  },
  organisation: {
    organisationList() {
      return [{
        title: t('phrase.my_organisations'),
      }];
    },
    registerCommercial(commercialType) {
      if (commercialType) {
        return [
          {
            title: t('phrase.register_commercial'),
            routeTo: { name: 'organisation-register-research-start' },
          },
          {
            title: tc(`word.${commercialType}_commercial`, 1),
          },
        ];
      }
      return [
        { title: t('phrase.register_commercial') },
      ];
    },
    registerTest(commercialType) {
      if (commercialType) {
        return [
          {
            title: t('phrase.register_commercial'),
            routeTo: { name: 'organisation-register-research-start' },
          },
          {
            title: tc(`word.${commercialType}_commercial`, 1),
            routeTo: { name: 'organisation-register-research-start', query: { commercialType } },
          },
          {
            title: t('phrase.request_research'),
          },
        ];
      }
      return [
        {
          title: t('phrase.register_commercial'),
          routeTo: { name: 'organisation-register-research-start' },
        },
        {
          title: t('phrase.request_research'),
        },
      ];
    },
    organisationDetail() {
      return [
        { title: t('phrase.my_organisation') },
      ];
    },
    researchCreate() {
      return [
        {
          title: tc('word.research', 2),
          routeTo: { name: 'organisation-research-list' },
        },
        {
          title: t('phrase.register_research'),
        },
      ];
    },
    researchList() {
      return [
        { title: tc('word.research', 2) },
      ];
    },
    researchDetail(researchTitle) {
      return [
        {
          title: tc('word.research', 2),
          routeTo: { name: 'organisation-research-list' },
        },
        {
          title: researchTitle,
        },
      ];
    },
  },
};
